// Suffix of a duplicated sold-product name: 'copy' (en), 'copie' (ro),
// 'kopia' for every other language.
export const copyLabel = (language: string): string => {
  if (language === 'en') return 'copy';
  if (language === 'ro') return 'copie';
  return 'kopia';
};
